import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../settings/index';
import Api, { executeAction } from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import { t } from '../../../i18n';

const api = new Api('/jobs/requiring_attention');
const formDataApi = new Api('/jobs/adjustment_resolutions/form_data');

function addDetailsAction(records) {
  return records.map(item => {
    if (!item.actions) {
      item.actions = [];
    }

    item.actions.push({
      key: 'job_details_page',
    });

    return item;
  });
}

function* loadData({ payload }) {
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column = 'starts_at',
      order = 'descend',
      filter = '',
      job_group_id,
      expand,
      currentPage,
    } = payload;
    const isLoadMoreClicked = job_group_id && expand;

    const search = {
      ...payload,
      page: isLoadMoreClicked ? 1 : page, // When load more has been clicked set page to 1 but increase pageSize
      pageSize,
      column,
      order,
      filter,
      job_group_id,
    };

    const result = yield call(sendRequest, api.load, { search }, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      const { records, totalCount, filteredCount, sortable_columns, job_group, filters } = result.data.success.data;

      if (job_group && expand) {
        yield put(
          actions.loadMultiDayDataSuccess({
            data: addDetailsAction(records),
            total: totalCount,
            pageSize,
            currentPage,
            filteredTotal: filteredCount,
            sortableColumns: sortable_columns,
            jobGroup: job_group,
            search,
          }),
        );
      } else {
        yield put(
          actions.loadDataSuccess({
            data: addDetailsAction(records),
            total: totalCount,
            filteredTotal: filteredCount,
            pageSize,
            sortableColumns: sortable_columns,
            jobGroup: job_group,
            filters,
            search,
          }),
        );
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* processAction({ payload }) {
  try {
    const { method, url, cb, message } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result) {
      if (cb) {
        cb();
      }

      if (message) {
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message,
          }),
        );
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* assignModalLoadData() {
  try {
    const result = yield call(sendRequest, formDataApi.load, {}, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      const { admins } = result.data.success.data;
      yield put(actions.assignModalLoadDataSuccess(admins));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* assignToApprover({ payload }) {
  const { url, id, method, cb } = payload;
  const data = { assign: { responder_user_id: id } };

  try {
    const result = yield call(sendRequest, executeAction, { url, method, data }, notifications.REQUEST_ERROR);
    yield put(actions.hideAssignModal());

    if (result) {
      if (cb) {
        cb();
      }

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.assigned_successfully', {
            item: t('dash.jobs.attentionRequiredList.team_member_label'),
          }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD, loadData),
    takeEvery(actions.PROCESS_ACTION, processAction),
    takeEvery(actions.ASSIGN_TO_APPROVER, assignToApprover),
    takeEvery(actions.ASSIGN_MODAL_LOAD_DATA, assignModalLoadData),
  ]);
}
